import { animate, group, query, stagger, state, style, transition, trigger, } from '@angular/animations';
import { OnDestroy, } from '@angular/core';
import { BehaviorSubject, Subject, } from 'rxjs';
import { delay, takeUntil, } from 'rxjs/operators';
var TRANSITION_SPEED = 125;
var animations = [
    trigger('isExpanded', [
        transition('* <=> *', [
            query('button:enter', [
                style({ opacity: 0, marginRight: '-40px' }),
                stagger(-TRANSITION_SPEED / 2, [
                    group([
                        animate(TRANSITION_SPEED * 2, style({ opacity: 1 })),
                        animate(TRANSITION_SPEED + "ms ease-out", style({ marginRight: '10px' })),
                    ]),
                ]),
            ], { optional: true }),
            query('button:leave', [
                stagger(TRANSITION_SPEED / 4, [
                    group([
                        animate(TRANSITION_SPEED, style({ opacity: 0 })),
                        animate(TRANSITION_SPEED / 2 + "ms ease-in", style({ marginRight: '-40px' })),
                    ]),
                ]),
            ], { optional: true }),
        ]),
    ]),
    trigger('isOpen', [
        state('open', style({
            transform: 'none',
        })),
        state('closed', style({
            transform: 'rotate(-45deg)',
        })),
        transition('open <=> closed', animate(TRANSITION_SPEED + "ms ease-in-out")),
    ]),
];
var UiActionExpanderComponent = /** @class */ (function () {
    function UiActionExpanderComponent() {
        this._isCreateMenuExpanded$ = new BehaviorSubject(false);
        this._destroyed$ = new Subject();
        this.isActionExpanded$ = this._isCreateMenuExpanded$
            .pipe(
        // delay for element to become focusable
        delay(50), takeUntil(this._destroyed$));
    }
    Object.defineProperty(UiActionExpanderComponent.prototype, "isCreateMenuExpanded", {
        get: function () {
            return this._isCreateMenuExpanded$.value;
        },
        set: function (expand) {
            if (expand === this._isCreateMenuExpanded$.value) {
                return;
            }
            this._isCreateMenuExpanded$.next(expand);
        },
        enumerable: true,
        configurable: true
    });
    UiActionExpanderComponent.prototype.ngOnDestroy = function () {
        this._isCreateMenuExpanded$.complete();
        this._destroyed$.next();
    };
    return UiActionExpanderComponent;
}());
export { UiActionExpanderComponent };
